// extracted by mini-css-extract-plugin
module.exports = {"DashboardBackgroundImage":"ManagerDashboard_DashboardBackgroundImage__2dGIA","WelcomeText":"ManagerDashboard_WelcomeText__3uQEv"};